// extracted by mini-css-extract-plugin
export var fadeIn = "_j2-1";
export var modalContent = "_j2-3";
export var overlay = "_j2-0";
export var popoverContent = "_j2-2";
export var results = "_j2-5";
export var searchInputWrapper = "_j2-4";